
let nav = document.querySelector('.navbar-custom-wrap');
let navDesctop = document.querySelector('#navbar-desktop');
let navMobile = document.querySelector('#navbar-mobile');
let allHeight = Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight,
    document.body.offsetHeight, document.documentElement.offsetHeight,
    document.body.clientHeight, document.documentElement.clientHeight,
);

if (navDesctop && navMobile) {
    const navDesctopContainer = navDesctop.querySelector('.scroll-hidden');
    const navMobileContainer = navMobile.querySelector('.scroll-hidden');
    let navDesctopContainerHeignt = parseInt(getComputedStyle(navDesctopContainer).height)
    let navMobileContainerHeignt = parseInt(getComputedStyle(navMobileContainer).height);
    window.addEventListener('resize', () => {
        navDesctop = document.querySelector('#navbar-desktop');
        navMobile = document.querySelector('#navbar-mobile');
        navDesctopContainerHeignt = parseInt(getComputedStyle(navDesctopContainer).height)
        navMobileContainerHeignt = parseInt(getComputedStyle(navMobileContainer).height)
        allHeight = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight,
        );
    });
    let scrollCount = 0;
    let differenceSave = 0;

        // navDesctopContainer.addEventListener("click", ()=> {
        // navDesctopContainer.classList.add("on-top");
        // })

    document.addEventListener("scroll", () => {
        let scrollBy = window.scrollY;
        let bottomMark = allHeight - document.documentElement.clientHeight;
        if (window.innerWidth > 991 ) {
            if (scrollBy > scrollCount) {
                let differenceScroll = scrollBy - scrollCount;
                let offsetBy = parseInt(differenceSave + differenceScroll);
                if(offsetBy < navDesctopContainerHeignt){
                    if(scrollBy >= bottomMark || scrollBy +1 >= bottomMark){
                        nav.style.transform = `translateY(-${navDesctopContainerHeignt}px)`;
                    } else {
                        nav.style.transform = `translateY(-${offsetBy}px)`;
                        differenceSave = offsetBy;
                    };
                }else{
                    nav.style.transform = `translateY(-${navDesctopContainerHeignt}px)`;
                }
            } else {
                let differenceScroll = scrollCount - scrollBy;
                let offsetBy = parseInt(differenceSave - differenceScroll);

                if (offsetBy > 0){
                    nav.style.transform = `translateY(-${offsetBy}px)`;
                    differenceSave = offsetBy;
                } else {
                    nav.style.transform = `translateY(-0.5px)`;
                }

            }
        } else {
            if (scrollBy > scrollCount ) {
                let differenceScroll = scrollBy - scrollCount;
                let offsetBy = parseInt(differenceSave + differenceScroll);
                if (offsetBy < navMobileContainerHeignt){
                    if (scrollBy >= bottomMark || scrollBy +1 >= bottomMark ){
                        nav.style.transform = `translateY(-${navMobileContainerHeignt + 3}px)`;
                    } else {
                        nav.style.transform = `translateY(-${offsetBy + 3}px)`;
                        differenceSave = offsetBy;
                    };
                } else {
                    nav.style.transform = `translateY(-${navMobileContainerHeignt + 3}px)`;
                };
            } else {
                let differenceScroll = scrollCount - scrollBy;
                let offsetBy = parseInt(differenceSave - differenceScroll);
                nav.style.transform = `translateY(-${offsetBy + 3}px)`;
                if(offsetBy > 0){
                    differenceSave = offsetBy;
                }else{
                    nav.style.transform = `translateY(-0.5px)`;
                }

            }
        };
        scrollCount = scrollBy;
    });
};